import * as React from "react";
// tslint:disable-next-line:no-implicit-dependencies
import {Subscription} from "rxjs";
import RangedDatePicker, {RangedDatePickerProps} from "./RangedDatePicker";
import {DateRange} from "./RangedDatePickerController";
import "./RangedDatePickerWithOptions.scss";
import RangedDatePickerWithOptionsController from "./RangedDatePickerWithOptionsController";
import {DateRangePicker} from "@vebox/etui-core";

export interface RangedDatePickerWithOptionsOptions {
    optionName: string;
    optionRange: DateRange;
}

export interface RangedDatePickerWithOptionsProps extends RangedDatePickerProps {
    periodLabel?: any;
    options: RangedDatePickerWithOptionsOptions[];
    customText?: string;
    controller: RangedDatePickerWithOptionsController;
    defaultOption?: number;
    useETUIcomponent?: boolean;
}

export interface RangedDatePickerWithOptionsState {
    selectedOption: number;
    startDate: Date;
    endDate: Date;
}

export class RangedDatePickerWithOptions
    extends React.Component<RangedDatePickerWithOptionsProps, RangedDatePickerWithOptionsState> {

    private listenerSubscription: Subscription;

    constructor(props) {
        super(props);
        this.state = {
            selectedOption: this.props.defaultOption ? this.props.defaultOption : 0,
            startDate: undefined,
            endDate: undefined,
        };
    }

    public componentDidMount() {
        this.listenerSubscription = this.props.controller.listenToOption((value) => {
            if (value !== this.props.options.length) {
                const {start, end} = this.props.options[value].optionRange;
                this.props.controller.changeRange(start, end);
            } else {
                this.props.controller.changeRange(null, null);
            }
            this.setState({
                selectedOption: value,
            });
        });
    }

    public componentWillUnmount() {
        if (this.listenerSubscription) {
            this.listenerSubscription.unsubscribe();
        }
    }

    public render() {
        return (
            <div className={"RangedDatePickerWithOptions"}>
                <div
                    className={"selection-header"}
                    style={{
                        marginRight: this.state.selectedOption === this.props.options.length ? "10px" : null,
                    }}
                >
                    {this.props.periodLabel}
                    <select
                        value={this.state.selectedOption}
                        disabled={this.props.disabled}
                        className={"second-level-tabbar__dropdown"}
                        onChange={this.onOptionChanged}
                    >
                        {
                            this.props.options.map((elem, idx) => {
                                return (<option key={idx} value={idx}>{elem.optionName}</option>);
                            })
                        }
                        <option key={this.props.options.length} value={this.props.options.length}>
                            {this.props.customText}
                        </option>
                    </select>
                </div>
                {
                    this.state.selectedOption === this.props.options.length ?
                        (
                                <RangedDatePicker
                                    controller={this.props.controller}
                                    fromLabel={this.props.fromLabel}
                                    toLabel={this.props.toLabel}
                                    disabled={this.props.disabled}
                                    dateFormat={this.props.dateFormat}
                                    locale={this.props.locale}
                                    maxDate={this.props.maxDate}
                                    minDate={this.props.minDate}
                                    maxInterval={this.props.maxInterval}
                                />
                        ) : ""
                }
            </div>
        );
    }

    private onOptionChanged = (e) => {
        const value: number = Number(e.target.value);
        this.props.controller.changeOption(value);
    }
}
